module.exports = __webpack_public_path__ + "static/media/waterloo.31e73eb2.png";